import { CalculateProductionJobCostsQuery } from "~/gql/queries/produce/productionCost.generated";
import { CalculateRecipeCostQuery } from "~/gql/queries/produce/productionRecipes.generated";

export const recipeCostEndpoints = {
	CalculateProductionJobCosts: {
		providesTags: ["ProductionJobs"] as AddTagTypes,
		transformResponse: (res: CalculateProductionJobCostsQuery) => res
	},
	CalculateRecipeCost: {
		providesTags: ["ProductionRecipe"] as AddTagTypes,
		transformResponse: (res: CalculateRecipeCostQuery) => res
	}
};
